import { HelpVideoChildComponent } from '../helpVideoChildComponent';

const CandidatesSourcing = () => {
  const topicList = [
    { id: '826887643', label: 'AI Matching candidates' },
    { id: '827963624', label: 'How to use Similar Jobs' },
    { id: '840834742', label: 'How to Set Reminders on Wisestep' },
    { id: '840832338', label: 'How to add Events to Google Calendar' },
    { id: '856409187', label: 'How to search for a candidate' },
    { id: '856405551', label: 'How to submit a profile' },
  ];
  return <HelpVideoChildComponent isFromSettings={true} topicArrayList={topicList} />;
};

export default CandidatesSourcing;
